import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

// Wraps protected page content. Renders an access-denied notice when the
// current member class is not permitted to view the page.
export default function AccessGate({ pageKey, children }) {
  const { canAccess, user, permissions, classLabel } = useAuth();

  if (canAccess(pageKey)) return children;

  const allowed = (permissions[pageKey] || []).map((c) => classLabel(c)).join(', ');

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 fade-in">
      <div
        className="rounded-lg p-8 text-center bg-white shadow-md border"
        style={{ borderColor: 'rgba(0,0,0,0.08)' }}
      >
        <div
          className="mx-auto mb-5 flex items-center justify-center w-16 h-16 rounded-full"
          style={{ background: 'var(--maroon)' }}
        >
          <Lock size={28} color="var(--cream)" />
        </div>
        <h2 className="font-title text-2xl mb-2" style={{ color: 'var(--ink)' }}>
          Restricted Page
        </h2>
        {user ? (
          <p className="mb-4">
            Your membership class (<strong>{classLabel(user.memberClass)}</strong>) does not have access
            to this page.
          </p>
        ) : (
          <p className="mb-4">This page is restricted to members. Please log in to continue.</p>
        )}
        <p className="text-sm mb-6" style={{ color: 'var(--olive)' }}>
          Access permitted for: <em>{allowed || 'Administrators only'}</em>
        </p>
        {!user && (
          <Link
            to="/login"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded font-title transition-colors"
            style={{ background: 'var(--navy)', color: 'var(--cream)' }}
          >
            <LogIn size={16} /> Member Login
          </Link>
        )}
      </div>
    </div>
  );
}
